import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/Button';
import { cn } from 'utils/classnames';

interface PalletBuildBackButtonProps {
  onClick: () => void;
  light?: boolean;
}

export const PalletBuildBackButton = ({ onClick, light }: PalletBuildBackButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      className={cn(
        'absolute left-0 top-0 h-9 shrink-0 gap-1 rounded-full px-2',
        light
          ? 'text-white hover:bg-white/10 hover:text-white'
          : 'text-slate-500 hover:bg-slate-100 hover:text-slate-700'
      )}
    >
      <ChevronLeft className="h-5 w-5" />
      {t('palletBuildBackButton.goBack')}
    </Button>
  );
};
